module.exports = new __parcel__URL__("WarningState.d4e9b5c8.svg").toString();